import { render, staticRenderFns } from "./ContainerEditor.vue?vue&type=template&id=22485199"
import script from "./ContainerEditor.vue?vue&type=script&lang=js"
export * from "./ContainerEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports